var exports = {
  "E": "Text__9H1KOo",
  "a": "Box__brJthC",
};

module.exports = exports;
